import { Input, Radio } from "antd";
import styles from "../../shared/Evaluaciones.module.css";

function GrupoRubros({ items, incidentes, respuestas, onChange }) {
  return (
    <section className={styles.section}>
      <div className={styles.sectionHeading}>
        <h2>{incidentes ? "02 / No negociables" : "01 / Rubros de calidad"}</h2>
        <span>{incidentes ? "NO NEGOCIABLES" : "VALOR POR RUBRO"}</span>
      </div>
      {incidentes && (
        <p className={styles.hint}>
          Indica si cumple cada criterio no negociable.
        </p>
      )}
      <div className={styles.rubroHeader}>
        <span>Concepto / área de oportunidad</span>
        <span>Valor</span>
        <span>Cumple</span>
        <span>Resultado</span>
      </div>
      {items.map(rubro => {
        const respuesta = respuestas[rubro.id];
        const fallo = respuesta.siCumple === false;

        return (
          <div key={rubro.id} className={`${styles.rubro} ${fallo ? styles.failed : ""}`}>
            <div>
              <strong>{rubro.nombreRubro}</strong>
              <Input
                aria-label={`Área de oportunidad: ${rubro.nombreRubro}`}
                size="small"
                placeholder="Área de oportunidad (opcional)"
                value={respuesta.oportunidad}
                onChange={event => onChange(rubro.id, {
                  ...respuesta,
                  oportunidad: event.target.value,
                })}
              />
            </div>
            <span className={styles.mono}>{rubro.valor}</span>
            <Radio.Group
              size="small"
              value={respuesta.siCumple}
              onChange={event => onChange(rubro.id, {
                ...respuesta,
                siCumple: event.target.value,
              })}
              optionType="button"
              buttonStyle="solid"
              options={[{ label: "Sí", value: true }, { label: "No", value: false }]}
            />
            {/* Resultado pendiente de las reglas oficiales de calificación. */}
            <b className={styles.mono}>—</b>
          </div>
        );
      })}
    </section>
  );
}

export function RubrosEvaluacion({ respuestas, rubros, onChange }) {
  return (
    <>
      <GrupoRubros
        items={rubros.filter(rubro => !rubro.esNoNegociable)}
        incidentes={false}
        respuestas={respuestas}
        onChange={onChange}
      />
      <GrupoRubros
        items={rubros.filter(rubro => rubro.esNoNegociable)}
        incidentes
        respuestas={respuestas}
        onChange={onChange}
      />
    </>
  );
}
